import * as Sentry from '@sentry/browser';
import axios from 'axios';
class AuditLogService {
    static auth;
    static config;
    constructor(auth, config) {
        AuditLogService.auth = auth;
        AuditLogService.config = config;
    }
    headers() {
        return {
            Authorization: `Bearer ${AuditLogService.auth.currentToken}`,
        };
    }
    adminPortal = {
        query: async (entityType, entityID) => {
            try {
                const response = await axios({
                    method: 'GET',
                    url: `${AuditLogService.config.API.baseApiUrl}/audit-trail/for-entity/${entityType}/${entityID}`,
                    headers: this.headers(),
                });
                return response;
            }
            catch (error) {
                Sentry.captureException(error);
                return { status: 'error', data: [] };
            }
        },
    };
}
export default AuditLogService;
//# sourceMappingURL=AuditLog.service.js.map